// 售后中心-退款中心-自动审核退款

import {get, post, postJson, deleteApi, postUrl} from '../axios'

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/autoAuditRefund/'
const RESOURCE_BASE_PATH = '/autoAuditRefund/'

// 查询自动审核退款任务列表
export const getAutoAuditRefund = p => get(`${RESOURCE_BASE_PATH}`, p);

// 新增/编辑自动审核退款任务
export const addAutoAuditRefund = p => postJson(`${RESOURCE_BASE_PATH}`, p);

// 查询审核记录
export const getAuditRecord = p => get(`${RESOURCE_BASE_PATH}/auditRecord`, p);

// 更新开启状态/优先级
export const stateSort = p => postUrl(`${RESOURCE_BASE_PATH}state-sort`, p);

// 删除任务
export const delAutoAuditRefund = id => deleteApi(`${RESOURCE_BASE_PATH}${id}`);

// 查询任务详情（编辑使用）
export const getTaskDetail = id => get(`${RESOURCE_BASE_PATH}${id}`);